import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import LayoutLoading from "../components/Layouts/LayoutLoading"
import { useAuth } from "../hooks/useAuth"

function Index() {
  const navigate = useNavigate()
  const { checkAuth } = useAuth()

  useEffect(() => {
    let isMounted = true

    const initAuth = async () => {
      try {
        const isAuth = await checkAuth(true)
        if (!isMounted) return

        if (!isAuth) {
          navigate("/login", { replace: true })
        }
      } catch (err) {
        console.error("[Index]: Ошибка проверки сессии при старте:", err)
        if (isMounted) {
          navigate("/login", { replace: true })
        }
      }
    }

    initAuth()

    return () => {
      isMounted = false
    }
  }, [checkAuth, navigate])

  return (
    <LayoutLoading>
      <p className="text-center text-sm text-gray-500">
        Проверка авторизации...
      </p>
    </LayoutLoading>
  )
}

export default Index
